import { getSurveyAnswers } from "src/hooks/survey/answers";
import { getBMI } from "./medEligibility";
import { hasMedicareInsurance } from "./userSegment/features";

const MEDICARE_BRIDGE_DISQUALIFYING_CONDITIONS: string[] = [
  "obstructiveSleepApnea",
  "metabolicDysfunctionAssociatedSteatohepatitis",
];

const MEDICARE_BRIDGE_ELIGIBILITY_TIERS: {
  minBMI: number;
  qualifyingComorbidities?: string[];
}[] = [
  { minBMI: 35 },
  {
    minBMI: 30,
    qualifyingComorbidities: [
      "heartFailureWithPreservedEjectionFraction",
      "uncontrolledHypertension",
      "chronicKidneyDiseaseStage3aOrAbove",
      "preDiabetes",
      "previousMyocardialInfarction",
      "previousStroke",
      "symptomaticPeripheralArteryDisease",
    ],
  },
  {
    minBMI: 27,
    qualifyingComorbidities: [
      "preDiabetes",
      "previousMyocardialInfarction",
      "previousStroke",
      "symptomaticPeripheralArteryDisease",
    ],
  },
];

const hasAnyMedicareBridgeCondition = (
  conditions: string[],
  candidates: string[]
) => candidates.some((condition) => conditions.includes(condition));

export const isEligibleForMedicareBridge = () => {
  if (!hasMedicareInsurance()) {
    return false;
  }

  const surveyAnswers = getSurveyAnswers();
  const conditions: string[] = surveyAnswers.medicareBridgeConditions ?? [];

  const isDisqualified =
    surveyAnswers.currentHealthRiskMedical?.includes("type2Diabetes") ||
    hasAnyMedicareBridgeCondition(
      conditions,
      MEDICARE_BRIDGE_DISQUALIFYING_CONDITIONS
    );
  if (isDisqualified) {
    return false;
  }

  const bmi = getBMI();

  return MEDICARE_BRIDGE_ELIGIBILITY_TIERS.some(
    ({ minBMI, qualifyingComorbidities }) =>
      bmi >= minBMI &&
      (!qualifyingComorbidities ||
        hasAnyMedicareBridgeCondition(conditions, qualifyingComorbidities))
  );
};
